import type { Classification as ClassificationModel } from '@/adapters/catalogv1.g';

export function extractClassification(model: ClassificationModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.classification_ref ?? '',
    name: model.name ?? '',
    description: model.description ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogClassification = ReturnType<typeof extractClassification>;
